$(document).on("click", "[data-copy-element]", function () {
    let text = $(this).attr("data-copy-element");
    let notifyText = $(this).attr("data-notify-text");

    const type = "text/plain";
    const blob = new Blob([text], { type });
    const data = [new ClipboardItem({ [type]: blob })];
    navigator.clipboard.write(data);

    notify("success", notifyText, text);
});
